import React, { Component } from 'react';
import './styles.css'
import { iconEmpty, renderListOrder, renderHeaderSummary } from './../../../../services/helper'
import { typeError, getImageChannel } from './../../../../constants/order'
import moment from 'moment';
import { convertDateFromUTC } from './../../../../services/dst'
import lang from './../../../../languages/en'

class ImportResult extends Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.faltal = false

        renderListOrder();
        renderHeaderSummary();
    }

    renderRow = () => {
        const { resultImport } = this.props;
        if (!Object.keys(resultImport).length) {
            return (
                <tr>
                    <td colSpan={7}>{iconEmpty()}</td>
                </tr>
            )
        }
        return (
            <tr key={Date.now() + 100}>
                <td>{convertDateFromUTC(resultImport.ImportDatetime).format("MM/DD/YYYY HH:mm")}</td>
                <td className="icon-result">{getImageChannel(resultImport.ChannelName)}</td>
                <td>{resultImport.OrderCount}</td>
                <td>{resultImport.ImportCount}</td>
                <td>{resultImport.WarningCount}</td>
                <td className='td-fatal-count'>{resultImport.FatalCount}</td>
            </tr>
        )
    }

    renderRowChildren = () => {
        return this.props.resultImportDetail.map((e, i) => {
            typeError[e['ResultType']] === "FATAL" && (this.faltal = true)
            return (
                <tr className={'error-result-import ' + (typeError[e['ResultType']] !== "FATAL" ? "file-import-aborted-warning" : "")} key={i}>
                    <td className="col-te">{typeError[e['ResultType']]}</td>
                    <td className="col-line">{e.ErrorLine}</td>
                    <td className="col-col">{e.ErrorColumn}</td>
                    <td className="col-mess">{e.ErrorDetail}</td>
                </tr>
            )
        })
    }

    render() {

        return (
            <div id='import-result'>
                <h3>Import Result</h3>
                <div className='contain-table'>
                    <table>
                        <thead>
                            <tr className={'title ' + (this.faltal ? " occur-faltal" : '')}>
                                <th className='item1' colSpan={4}>{!this.faltal ? lang.title_table_file_import_success : lang.title_table_file_import_aborted}</th>
                                <th className='item2' colSpan={2}>Errors</th>
                            </tr>
                            <tr>
                                <th>Import Date Time</th>
                                <th>Channel</th>
                                <th>Order Count</th>
                                <th>Import Count</th>
                                <th className='col-count'>Warning Count</th>
                                <th className='col-count'>Fatal Count</th>
                            </tr>
                        </thead>
                        <tbody className={this.faltal ? "tbody-occur-faltal" : ''}>
                            {this.renderRow()}
                            {this.props.resultImportDetail.length ? (
                                <tr>
                                    <td colSpan={7} className='childen-table-import-result'>
                                        <table className="tbl-fix tbl-grey tbl-import-warn">
                                            <thead>
                                                <tr>
                                                    <th className="col-te">Type</th>
                                                    <th className="col-line">Line</th>
                                                    <th className="col-col">Column</th>
                                                    <th className="col-mess">Detail</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.renderRowChildren()}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            ) : null}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default ImportResult;


// WEBPACK FOOTER //
// ./src/components/step-import-order/components/import-result/index.js